import {
    GET_VACATIONS,
    EDIT_VACATION,
    DELETE_VACATION
} from '../actions/vacations';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    let index = -1;
    switch (action.type) {
        case GET_VACATIONS:
            return [].concat(action.value);
        case EDIT_VACATION:
            index = _.findIndex(state, { '_id':  action.value._id});
            state[index] = action.value;
            return [].concat(state);
        case DELETE_VACATION:
            index = _.findIndex(state, { '_id':  action.value._id});
            if (index !== -1) {
                state.splice(index, 1);
            }
            return [].concat(state);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/vacations.js